import { seo } from "@/utils/seo";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/calendars/$calendarId")({
  component: Outlet,
  beforeLoad: () => ({
    breadcrumb: "Edit Calendar",
  }),
  head: () => ({
    meta: seo({ title: "Edit Calendar" }),
  }),
});
